import getAutoCollectionEnabled from '../selectors/getAutoCollectionEnabled';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    EventCaptureOptions,
} from 'owa-outlook-service-options';

export default function areGuidedCaptureOptionsDirty(): boolean {
    let autoCollectionEnabled = getAutoCollectionEnabled();
    let userOptions = getOptionsForFeature<EventCaptureOptions>(OwsOptionsFeatureType.EventCapture);

    return autoCollectionEnabled != userOptions.autoCollectionEnabled;
}
